import { useTranslation } from 'react-i18next';

import styles from '@/components/atoms/Accordion/templates/ConnectionStatusAccordion.module.scss';
import PlainFooterFieldset from '@/components/atoms/Fieldset/templates/PlainFooterFieldset';
import { Badge } from '@/components/ui/badge';

interface Props {
  onOAuthClick: () => void;
}

export const ReAuthFieldset = ({ onOAuthClick }: Props) => {
  const { t } = useTranslation();

  return (
    <PlainFooterFieldset
      title={
        <div className={styles.accordion_title}>
          <span className="text-base leading-6 font-semibold">
            {t('integrations.con_status.title')}{' '}
          </span>
          <Badge type="secondary" flavour="warning">
            {t('pages.unauthorized')}
          </Badge>
        </div>
      }
      subtitle={t('integrations.sunco.disconnected')}
      primaryButton={{ children: t('integrations.reauthorize'), onClick: onOAuthClick }}
      fullContentWidth
    />
  );
};
